import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import type { ProjectCategoryRecord } from '#shared/cms/records'

type ProjectCategoryValue = Omit<ProjectCategoryRecord, '$type'>

interface CategoryEntry {
  rkey: string
  uri: string
  cid: string
  value: ProjectCategoryRecord
}

// `watch: false` stops useFetch firing one last `/.../undefined` request
// when `navigateTo` clears `route.params.rkey` on unmount.

export default /*@__PURE__*/_defineComponent({
  __name: '[rkey]',
  setup(__props) {

definePageMeta({ layout: false })
useHead({ title: 'Edit project category - admin - Daniel Roe' })

const route = useRoute()
const rkey = computed(() => {
  const raw = route.params.rkey
  return typeof raw === 'string' && raw ? raw : null
})

if (!rkey.value) {
  throw createError({ statusCode: 404, statusMessage: 'Missing rkey.' })
}

const { data, loading } = useAdminFetch<CategoryEntry>(`/api/admin/project-categories/${rkey.value}`, {
  watch: false,
})

async function save (value: ProjectCategoryValue) {
  if (!rkey.value) return
  await $fetch(`/api/admin/project-categories/${rkey.value}`, { method: 'PUT', body: value })
  await navigateTo('/admin/projects')
}

return (_ctx: any,_cache: any) => {
  const _component_AdminProjectCategoryForm = _resolveComponent("AdminProjectCategoryForm")!
  const _component_AdminSkeletonForm = _resolveComponent("AdminSkeletonForm")!
  const _component_AdminShell = _resolveComponent("AdminShell")!

  return (_openBlock(), _createBlock(_component_AdminShell, { title: "Edit project category" }, {
    default: _withCtx(() => [
      (_unref(data))
        ? (_openBlock(), _createBlock(_component_AdminProjectCategoryForm, {
            key: 0,
            initial: _unref(data).value,
            "submit-label": "Save",
            onSubmit: save
          }, null, 8, ["initial"]))
        : (_unref(loading))
          ? (_openBlock(), _createBlock(_component_AdminSkeletonForm, {
              key: 1,
              fields: ['text', 'text']
            }))
          : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})